import { render, staticRenderFns } from "./kplus-gen.vue?vue&type=template&id=57bba9e5&scoped=true&"
import script from "./kplus-gen.vue?vue&type=script&lang=js&"
export * from "./kplus-gen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bba9e5",
  null
  
)

export default component.exports